import { GenericDropdownOption } from 'App.types';
import { creatorbase } from '@round/api';

export const orderingOptions: GenericDropdownOption<creatorbase.GetPostsParams['ordering']>[] = [
    {
        value: '-view_count',
        label: 'Views',
    },
    {
        value: '-published_date',
        label: 'Created date',
    },
    {
        value: '-engagement_rate',
        label: 'Engagement rate',
    },
    {
        value: '-like_count',
        label: 'Likes',
    },
    {
        value: '-comment_count',
        label: 'Comments',
    },
    {
        value: '-save_count',
        label: 'Saves',
    },
    {
        value: '-share_count',
        label: 'Shares',
    },
];
